import React from 'react';
import {
    contextSelectorDispatch,
    contextSelectors,
} from '@klp/contextSelector';
import { ActionButton, Tooltip } from '@klp/design';
import { IconName, Illustration } from '@klp/design/Illustrations';
import { Avatar, ListItem, ListItemText } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';

const styles = () => ({
    selectedItem: {
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
    },
    shortText: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    button: {
        maxWidth: '100%',
    },
});

export const SelectedContextHeader: React.FC = () => {
    const { selectedContext } = useSelector(contextSelectors);
    const { clearSelectedContextFromStorage } =
        contextSelectorDispatch(useDispatch());

    const classes = useKlpStyles({}, styles);

    if (!selectedContext?.nummer) return null;

    return (
        <ListItem component="div" className={classes.selectedItem}>
            <ListItemText>
                <ActionButton
                    actionType="cancel"
                    onClick={clearSelectedContextFromStorage}
                    className={classes.button}
                    variant="outlined"
                    size="medium"
                    endIcon={
                        selectedContext.hovedVisningsBilde ? (
                            <Avatar src={selectedContext.hovedVisningsBilde} />
                        ) : (
                            <Illustration
                                size="medium"
                                icon={IconName.HOUSE}
                                klpPalette="secondary"
                                klpColor="main"
                            />
                        )
                    }
                >
                    <Tooltip title={selectedContext?.navn}>
                        <span className={classes.shortText}>
                            {selectedContext?.navn}
                        </span>
                    </Tooltip>
                </ActionButton>
            </ListItemText>
        </ListItem>
    );
};
